/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";

type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired" | "archived";
  offerType?: "dining" | "event" | "expired" | "experience" | "others";
};

const OfferTable = ({
  actionType = "active",
  offerType = "dining",
}: OfferTableProps) => {
  const navigate = useNavigate();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const rows = [
    {
      id: 1,
      OfferName: "The Residence Tunis",
      StartDate: "26-Jun-2025",
      EndDate: "28-Jun-2025",
      ButterflyEffect: "Yes",
      CancellationPolicy: "Yes",
      eventTime: "6:00 PM",
    },
    {
      id: 2,
      OfferName: "The Residence Tunis",
      StartDate: "26-Jun-2025",
      EndDate: "28-Jun-2025",
      ButterflyEffect: "Yes",
      CancellationPolicy: "Yes",
      eventTime: "6:00 PM",
    },
    {
      id: 3,
      OfferName: "The Residence Tunis",
      StartDate: "26-Jun-2025",
      EndDate: "28-Jun-2025",
      ButterflyEffect: "Yes",
      CancellationPolicy: "Yes",
      eventTime: "6:00 PM",
    },
    {
      id: 4,
      OfferName: "The Residence Tunis",
      StartDate: "26-Jun-2025",
      EndDate: "28-Jun-2025",
      eventTime: "6:00 PM",

      ButterflyEffect: "Yes",
      CancellationPolicy: "Yes",
    },
    {
      id: 5,
      OfferName: "The Residence Tunis",
      StartDate: "26-Jun-2025",
      EndDate: "28-Jun-2025",
      eventTime: "6:00 PM",
      ButterflyEffect: "Yes",
      CancellationPolicy: "Yes",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      field: "OfferName",
      headerName: "Offer Name",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer", color: "#1976d2" }}
          onClick={() =>
            navigate("/manage-offer/preview-offer-detail", {
              state: {
                type:
                  offerType === "event"
                    ? "EVENT"
                    : offerType === "experience"
                      ? "EXPERIENCE"
                      : "RESTAURANT", // fallback
              },
            })
          }
        >
          <p>{params.value}</p>
        </div>
      ),
    },

    // Conditionally include StartDate column
    ...(offerType === "experience"
      ? []
      : [
        {
          field: "StartDate",
          headerName: offerType === "event" ? "Event Date" : "Start Date",
          flex: 1,
          minWidth: 95,
        },
      ]),

    {
      field: offerType === "event" ? "eventTime" : "EndDate",
      headerName: offerType === "event" ? "Event Time" : "End Date",
      flex: 1,
      minWidth: 95,
    },
    {
      field: "ButterflyEffect",
      headerName: "Butterfly Effect",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "CancellationPolicy",
      headerName: "Cancellation Policy",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 130,
      renderCell: () => {
        if (actionType === "active") {
          return (
            <div className="table_actions v2">
              <IconButton className="toggle_btn">
                <IosSwitchMain />
              </IconButton>
              <IconButton
                className="edit_icon"
                onClick={() => navigate("/manage-offer/build-offer")}
              >
                <img src="/static/images/edit_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "scheduled") {
          return (
            <div className="table_actions v2">
              <IconButton className="edit_icon">
                <img src="/static/images/calendar_icon.svg" alt="icon" />
              </IconButton>
              <IconButton
                className="edit_icon"
                onClick={() => navigate("/manage-offer/build-offer")}
              >
                <img src="/static/images/edit_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "expired" || actionType === "archived") {
          return (
            <div className="table_actions v2">
              <IconButton className="edit_icon">
                <img src="/static/images/copy_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        }
        return null;
      },
    },
  ];

  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table cards table_cards">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>
    </>
  );
};

export default OfferTable;
